const scheduledServicesByUserAndDayModal = {
  titleScheduled: "Scheduled Services",
  titleCompleted: "Completed Services",
  serialNumber: "Serial Number",
  place: "Place",
  scheduledDate: "Scheduled Date",
  accountable: "Accountable",
  confirm: 'Do you really want to delete this scheduled service?',
  title: 'DELETE SCHEDULED SERVICE'
};

export default scheduledServicesByUserAndDayModal;
